import styled from "styled-components";

export const Container = styled.div``;

export const MatchForm = styled.ul`
  display: flex;
  margin: 0 0 0 1rem;
  padding: 0;
  align-items: center;
  justify-content: flex-end;
  min-width: 64px;
`;

export const Indicator = styled.li<{ result: string }>`
  list-style-type: none;
  border-radius: 50%;
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.8rem;

  background: ${(props) => {
    if (props.result === "W") return props.theme.formWin;
    if (props.result === "D") return props.theme.push;
    if (props.result === "L") return props.theme.formLoss;
    if (props.result === "LW" || props.result === "LL") return "none";
  }};
  border: ${(props) => {
    if (props.result === "LW") return `1px solid ${props.theme.formWin}`;
    if (props.result === "LL") return `1px solid ${props.theme.formLoss}`;
  }};

  &:last-child {
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0rem;
  }
`;
